import { render, staticRenderFns } from "./customize.vue?vue&type=template&id=37b7205a&scoped=true"
import script from "./customize.vue?vue&type=script&lang=js"
export * from "./customize.vue?vue&type=script&lang=js"
import style0 from "./customize.vue?vue&type=style&index=0&id=37b7205a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b7205a",
  null
  
)

export default component.exports